module.exports = __webpack_public_path__ + "img/premium_04.57d96f9e.jpg";